import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const TemplatePage = Loadable(lazy(() => import('pages/template')));
const CreateTemplatePage = Loadable(lazy(() => import('pages/createTemplate')));
const CreateMailTemplatePage = Loadable(lazy(() => import('pages/createMailTemplate')));
const MailConfig = Loadable(lazy(() => import('pages/mailConfig')));
const ComparePage = Loadable(lazy(() => import('pages/compare')));
const RequestPage = Loadable(lazy(() => import('pages/request')));
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const HistoryPage = Loadable(lazy(() => import('pages/history')));
// const DashboardAnalytics= Loadable(lazy(() => import('pages/dashboard/analytics')));
const InactivePage = Loadable(lazy(() => import('pages/inactive_template')));
const InactiveMailPage = Loadable(lazy(() => import('pages/inactive_mail_template')));
const AppContactUS = Loadable(lazy(() => import('pages/contact-us')));
const SupplierConfig = Loadable(lazy(() => import('pages/supplierConfig')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: "dashboard",
          element: <DashboardDefault />,

          // children: [
          //   {
          //     path: "",
          //     element: <DashboardDefault />,
          //   },
            // {
            //   path: "analytics",
            //   element: <DashboardAnalytics />,
            // },
          // ],
        },
        // {
        //   path: '/',
        //   element: <RequestPage />,
        // },
        // {
        //   path: "dashboard",
        //   element: <DashboardPage />,
        //   rights: "compare.request",
        // },
        {
          path: 'overview',
          element: <RequestPage />,
          rights: 'compare.login',
        },
        {
          path: 'overview/:id/compare',
          element: <ComparePage />,
          rights: 'ngtCompare',
        },
        {
          path: 'compare/:id/:type?',
          element: <ComparePage />,
          rights: 'ngtCompare',
        },
        {
          path: 'compareTemplates',
          element: <TemplatePage />,
          rights: 'compare.template',
        },
        {
          path: 'compareTemplates/create',
          element: <CreateTemplatePage />,
          rights: 'compare.template',
        },
        {
          path: 'compareTemplates/createMail',
          element: <CreateMailTemplatePage />,
          rights: 'compare.template',
        },
        {
          path: 'compareTemplates/config',
          element: <MailConfig />,
          rights: 'compare.template',
        },
        {
          path: 'compareTemplates/:id/edit',
          element: <CreateTemplatePage />,
          rights: 'compare.template',
        },
        {
          path: 'compareTemplates/:id/editMail',
          element: <CreateMailTemplatePage />,
          rights: 'compare.template',
        },
        {
          path: 'compareTemplates/inactive',
          element: <InactivePage />,
          rights: 'compare.template',
        },
        {
          path: 'compareTemplates/inactiveMail',
          element: <InactiveMailPage />,
          rights: 'compare.template',
        },
        {
          path: 'compareTemplates/supplierConfig',
          element: <SupplierConfig />,
          rights: 'compare.template',
        },
        {
          path: '*',
          element: <RequestPage />,
          rights: 'compare.login',
        },
        {
          path: 'history',
          element: <HistoryPage />,
          rights: 'compare.history'
        }
      ],
    },
    // {
    //   path: "/maintenance",
    //   element: <CommonLayout />,
    //   children: [
    //     {
    //       path: "404",
    //       element: <MaintenanceError />,
    //     },
    //     {
    //       path: "500",
    //       element: <MaintenanceError500 />,
    //     },
    //     {
    //       path: "under-construction",
    //       element: <MaintenanceUnderConstruction />,
    //     },
    //     {
    //       path: "coming-soon",
    //       element: <MaintenanceComingSoon />,
    //     },
    //   ],
    // },
    // {
    //   path: "/auth",
    //   element: <CommonLayout />,
    //   children: [
    //     {
    //       path: "login",
    //       element: <AuthLogin />,
    //     },
    //     {
    //       path: "register",
    //       element: <AuthRegister />,
    //     },
    //     {
    //       path: "forgot-password",
    //       element: <AuthForgotPassword />,
    //     },
    //     {
    //       path: "reset-password",
    //       element: <AuthResetPassword />,
    //     },
    //     {
    //       path: "check-mail",
    //       element: <AuthCheckMail />,
    //     },
    //     {
    //       path: "code-verification",
    //       element: <AuthCodeVerification />,
    //     },
    //   ],
    // },
    {
      path: '/',
      element: <CommonLayout layout='simple' />,
      children: [
        {
          path: 'contact-us',
          element: <AppContactUS />,
        },
      ],
    },
  ],
};

export default MainRoutes;
